import * as stylex from '@stylexjs/stylex'
import { type ElementType } from 'react'
import { Box, type BoxProps } from '../Box/Box'

const baseStyles = stylex.create({
  root: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
})

export type HStackProps<RootComponent extends ElementType = 'div', BoxElement extends HTMLElement = HTMLDivElement> = BoxProps<RootComponent, BoxElement>

/**
 * HStack 是水平排列的 flex 容器（flexDirection: row），預設啟用 flexWrap。
 * 繼承 Box 的所有 ExtendStyleProps（gap、padding、margin 等）。
 *
 * @example
 * ```tsx
 * <HStack gap={2}>
 *   <Button>按鈕 A</Button>
 *   <Button>按鈕 B</Button>
 * </HStack>
 * ```
 */
export function HStack<RootComponent extends ElementType = 'div', BoxElement extends HTMLElement = HTMLDivElement>(
  props: HStackProps<RootComponent, BoxElement>,
) {
  const { component = 'div', rootStyle, ...rest } = props
  return (
    <Box component={component} rootStyle={[baseStyles.root, rootStyle]} {...rest} />
  )
}
